var exports = {
  "spinner": "Spinner.module__spinner___MTJYV0",
  "spinnerInner": "Spinner.module__spinnerInner___MTJYV0",
  "spinnerItem": "Spinner.module__spinnerItem___MTJYV0",
  "spinnerPulsingEllipsis": "Spinner.module__spinnerPulsingEllipsis___MTJYV0",
  "small": "Spinner.module__small___MTJYV0",
  "medium": "Spinner.module__medium___MTJYV0",
  "large": "Spinner.module__large___MTJYV0",
  "delay1": "Spinner.module__delay1___MTJYV0",
  "delay2": "Spinner.module__delay2___MTJYV0",
  "srOnly": "Spinner.module__srOnly___MTJYV0",
};

__webpack_require__.r(module.exports = exports);
